document.addEventListener('DOMContentLoaded', function () {

  var main = new Splide( '.mainProduct-gallery', {
    type: 'slide',
    pagination: false,
    arrows    : true,
    gap: '10px',
    lazyLoad: false,
  })

  main.mount()

  const galleryDiv = document.querySelector('.mainProduct-gallery')

  main.on( 'move', function (index) {
    if ( index ) {
      galleryDiv.classList.add('not-first-slide');
    } else {
      galleryDiv.classList.remove('not-first-slide');
    }
  });

  const mainForm = document.querySelector('.product-single__form')
  const purchaseOptions = mainForm.querySelectorAll('.mpk-purchase-option')
  const purchaseTabs = mainForm.querySelectorAll('.mpk-purchase-type')
  const selectedOption = mainForm.querySelector('.mpk-purchase-option.selected')
  const frequencySel = mainForm.querySelector('.mpk-plan-frequency')
  const variantInput = mainForm.querySelector('#variant_id')
  const planInput = mainForm.querySelector('#selling_plan_id')
  const quantityInput = mainForm.querySelector('#quantity')
  const fakeQuantityInput = mainForm.querySelector('#fake-quantity')
  const qtButtons = mainForm.querySelectorAll('.mpk-quantity-row button')
  const isES = document.documentElement.lang === 'es' || document.documentElement.lang === 'es-ES'

  qtButtons.forEach(button => {
    button.addEventListener('click', function() {
      const currentOption = mainForm.querySelector('.mpk-purchase-option.selected')
      const bundledProductId = currentOption.getAttribute('data-bundled-product')
      const existingBundledInput = document.querySelector('#bundled_quantity');
      let currentQty = Number(fakeQuantityInput.value)
      if ( button.classList.contains('mpk-qty-increase') ) {
        currentQty += 1
      } else if ( button.classList.contains('mpk-qty-decrease') ) {
        if ( currentQty > 1 ) {
          currentQty -= 1
        }
      }
      fakeQuantityInput.value = currentQty
      quantityInput.value = currentQty

      if ( bundledProductId ) {
        quantityInput.value = currentQty * Number(currentOption.getAttribute('data-quantity'))
        if ( existingBundledInput ) {
          existingBundledInput.value = currentQty
        }
      }

      //TODO: loop the options and select one based on qty
      //rules: if the variant id is the same and qty(if the option has a bundled product and is not checked as count as one then add the bundled quantity) is the same, select that option

      if ( currentQty == 3 
           && currentOption.getAttribute('data-variant-id') == '44452475633801'
           && currentOption.getAttribute('data-quantity') == '1'
           && currentOption.classList.contains('otp') 
           && !bundledProductId
          ) {
        const specialOption = mainForm.querySelector('.mpk-purchase-option.otp[data-variant-id="44452475633801"][data-quantity="3"]')
        if ( specialOption ) {
          selectOption( specialOption )
        }
      }

      if ( currentQty != 3 
           && currentOption.getAttribute('data-variant-id') == '44452475633801' 
           && currentOption.getAttribute('data-quantity') == '3'
           && currentOption.classList.contains('otp') 
           && !bundledProductId
          ) {
        const normalOption = mainForm.querySelector('.mpk-purchase-option.otp[data-variant-id="44452475633801"][data-quantity="1"]')
        if ( normalOption ) {
          selectOption( normalOption, currentQty )
        }
      }

    })
  })

  fakeQuantityInput.addEventListener('change', function() {
    quantityInput.value = fakeQuantityInput.value
  })

  const buildPlanSelector = ( option ) => {
    const planAttributes = Array.from(option.attributes).filter(attr => attr.name.startsWith('data-plan-id-'))
    const planList = []
    const isUniquePlan = option.getAttribute('data-unique-plan')
    const selectedPlan = option.getAttribute('data-selling-plan')
    planAttributes.forEach(attr => {
      const planId = attr.value
      const planIndex = Number(attr.name.replace('data-plan-id-', ''))
      const planName = option.getAttribute(`data-plan-name-${planIndex}`)
      planList.push({ id: planId, name: planName })
    });

    frequencySel.innerHTML = ''
    if ( isUniquePlan && isUniquePlan === 'true' ) {
      const plan = planList.find(p => p.id == option.getAttribute('data-selling-plan'))
      const opt = document.createElement('option')
      opt.value = plan.id
      opt.textContent = plan.name.replace('Delivery ', '')
      if ( isES ) {
        opt.textContent = opt.textContent.replace('every', 'cada').replace('days', 'días')
      }
      frequencySel.appendChild(opt)
    } else {
      planList.forEach(plan => {
        const opt = document.createElement('option')
        opt.value = plan.id
        opt.textContent = plan.name.replace('Delivery ', '')
        if ( isES ) {
          opt.textContent = opt.textContent.replace('every', 'cada').replace('days', 'días')
        }
        frequencySel.appendChild(opt)
      })
    }
    frequencySel.value = selectedPlan
  }

  frequencySel.addEventListener('change', function() {
    const selectedPlanId = frequencySel.value
    planInput.value = selectedPlanId
  })

  let firstLoad = true;

  const gifts = document.querySelectorAll('.mpk-gift')
  const giftsWrapper = document.querySelector('.mpk-gift-list')

  const selectOption = ( option, fixedQuantity ) => {
    if ( option.classList.contains('selected') && !firstLoad ) {
      console.log('already selected');
      option.parentElement.classList.toggle('open');
      return
    }
    firstLoad = false;
    option.parentElement.classList.remove('open');

    const variantId = option.getAttribute('data-variant-id')
    const planId = option.getAttribute('data-selling-plan')
    const quantity = option.getAttribute('data-quantity') || 1
    purchaseOptions.forEach(opt => opt.classList.remove('selected'));
    option.classList.add('selected');
    const bundledProductId = option.getAttribute('data-bundled-product')
    const bundledProductQt = option.getAttribute('data-bundled-quantity')
    const isSub = planId && planId !== ''
    const subTab = mainForm.querySelector('.mpk-purchase-type[data-purchase-type="sub"]')
    const subPriceEl = subTab.querySelector('.mpk-price')
    const subCompareEl = subTab.querySelector('.mpk-compare-at')
    const otpTab = mainForm.querySelector('.mpk-purchase-type[data-purchase-type="otp"]')
    const oneTimePriceEl = otpTab.querySelector('.mpk-price')
    const oneTimeCompareEl = otpTab.querySelector('.mpk-compare-at')
    const savingBannerText = option.getAttribute('data-saving-badge')
    const savingBanner = mainForm.querySelector('.mpk-save-label')
    const optionIndex = Array.from(purchaseOptions).indexOf(option);
    const planType = isSub ? 'sub' : 'otp';

    if ( !mainForm.classList.contains( planType + '-selected') ) {
      mainForm.classList.remove('sub-selected', 'otp-selected')
      mainForm.classList.add( planType + '-selected' )
      purchaseTabs.forEach(t => t.classList.remove('selected'))
      const selectedTab = mainForm.querySelector(`.mpk-purchase-type[data-purchase-type="${planType}"]`)
      if ( selectedTab ) {
        selectedTab.classList.add('selected')
      }
    }

    const otpPrice = option.getAttribute('data-price')
    if ( otpPrice && otpPrice !== '' ) {
      otpTab.style.display = 'flex'
      oneTimePriceEl.textContent = `$${otpPrice}`
      const otpCompareAt = option.getAttribute('data-compare-at')
      if ( otpCompareAt && otpCompareAt !== '' ) {
        oneTimeCompareEl.style.display = 'inline-block'
        oneTimeCompareEl.textContent = `$${otpCompareAt}`
      } else {
        oneTimeCompareEl.style.display = 'none'
      }
    } else {
      otpTab.style.display = 'none'
    }

    const subPrice = option.getAttribute('data-sub-price')
    if ( subPrice && subPrice !== '' ) {
      subTab.style.display = 'block'
      subPriceEl.textContent = `$${subPrice}`
      const subCompareAt = option.getAttribute('data-sub-compare-at')
      if ( subCompareAt && subCompareAt !== '' ) {
        subCompareEl.style.display = 'inline-block'
        subCompareEl.textContent = `$${subCompareAt}`
      } else {
        subCompareEl.style.display = 'none'
      }

      buildPlanSelector( option )
    } else {
      subTab.style.display = 'none'
    }

    const setSavingBadge = ( savingBannerText )=>{
      if ( savingBannerText && savingBannerText !== '' ) {
        savingBanner.textContent = savingBannerText
        savingBanner.style.display = 'inline-block'
      } else {
        savingBanner.style.display = 'none'
      }
    }

    setSavingBadge( savingBannerText )

    let linkedOption = null
    if ( !isSub) {
      const optionTitle = option.querySelector('.mpk-option-text label').textContent
      purchaseOptions.forEach(opt => {
        const optTitle = opt.querySelector('.mpk-option-text label').textContent
        const optPlanId = opt.getAttribute('data-selling-plan')
        if ( optTitle === optionTitle && optPlanId && optPlanId !== '' ) {
          linkedOption = opt
        }
      })
    }

    if ( linkedOption ) {
      const linkedSavingBannerText = linkedOption.getAttribute('data-saving-badge')
      setSavingBadge( linkedSavingBannerText )

      buildPlanSelector( linkedOption )
    }

    let computedQuantity = quantity

    if ( fixedQuantity ) {
      computedQuantity = fixedQuantity
    }

    variantInput.value = variantId
    quantityInput.value = computedQuantity
    //TODO: check here if the option is marked as "count as one" for bundled products, if not add bundled to quantity
    fakeQuantityInput.value = bundledProductId ? 1 : computedQuantity

    if ( isSub ) {
      planInput.value = planId
    } else {
      planInput.value = ''
    }

    const existingBundledInput = document.querySelector('#bundled_id');
    const existingBundledQtyInput = document.querySelector('#bundled_quantity');
    if ( existingBundledInput ) {
      existingBundledInput.remove();
    }
    if ( existingBundledQtyInput ) {
      existingBundledQtyInput.remove();
    }

    if ( bundledProductId ) {
      const bundledInput = document.createElement('input');
      bundledInput.id = 'bundled_id';
      bundledInput.type = 'hidden';
      bundledInput.name = 'items[1]id';
      bundledInput.value = bundledProductId;
      mainForm.appendChild(bundledInput);
      const quantityInputHidden = document.createElement('input');
      quantityInputHidden.id = 'bundled_quantity';
      quantityInputHidden.name = 'items[1]quantity';
      quantityInputHidden.type = 'hidden';
      quantityInputHidden.value = bundledProductQt || 1;
      mainForm.appendChild(quantityInputHidden);
    }

    const subText = isES ? 'Subscribirse' : 'Subscribe'
    const otpText = isES ? 'Agregar al carrito' : 'Add to cart'
    const customCTA = option.getAttribute('data-custom-cta')
    const ctaButton = mainForm.querySelector('.mpk-add-to-cart span')
    ctaButton.textContent = customCTA != '' ? customCTA : ( isSub ? subText : otpText )

    if ( gifts && gifts.length ) {
      gifts.forEach((gift, index) => {
        if ( option.dataset['gift' + ( index + 1 )] ) { 
          gift.classList.add('unlocked');
        } else { 
          gift.classList.remove('unlocked');
        }
      })

      const classesToRemove = Array.from(giftsWrapper.classList).filter(className => className.startsWith('option-index'));
      classesToRemove.forEach(className => giftsWrapper.classList.remove(className));
      giftsWrapper.classList.add(`option-index-${optionIndex+1}`);
    }

  }

  const ambarLink = document.querySelector('.hpn-annbar-link');
  if ( ambarLink ) {
    ambarLink.href = '#';
    ambarLink.addEventListener('click', function(e) {
      e.preventDefault();
      console.log('Annbar clicked', document.querySelector('.mpk-purchase-option[data-default-option="true"]'));
      const defaultOption = document.querySelector('.mpk-purchase-option[data-default-option="true"]') || purchaseOptions[0];
      selectOption( defaultOption );
      document.querySelector('form.bcolors-form .mpk-add-to-cart').click();
    })
  }

  if ( purchaseOptions.length ) {
    purchaseOptions.forEach(option => {
      option.addEventListener('click', function() {
        selectOption( option )
      })
    })
  }
  if ( selectedOption ) {
    selectOption( selectedOption )
  }

  if ( purchaseTabs.length ) {
    purchaseTabs.forEach(tab => {
      tab.addEventListener('click', function() {
        if ( tab.classList.contains('selected') ) return
        purchaseTabs.forEach(t => t.classList.remove('selected'))
        tab.classList.add('selected')
        const purchaseType = tab.getAttribute('data-purchase-type')
        mainForm.classList.remove('sub-selected', 'otp-selected')
        mainForm.classList.add(purchaseType + '-selected')

        const currentOption = mainForm.querySelector('.mpk-purchase-option.selected')
        const currentOptionTitle = currentOption.querySelector('.mpk-option-text label').textContent
        let nextOption = false
        purchaseOptions.forEach(option => {
          const optionTitle = option.querySelector('.mpk-option-text label').textContent
          if ( optionTitle === currentOptionTitle && !option.classList.contains('selected') ) {
            nextOption = option
          }
        })
        if ( nextOption ) {
          selectOption( nextOption )
        } else {
          selectOption( purchaseOptions[0] )
        }
      })
    })
  }

  const videoPopups = document.querySelectorAll('.hpn-video-parent')
  if ( videoPopups.length ) {
    videoPopups.forEach(vid => {
      vid.querySelector('.hpn-video-close').addEventListener('click', function(e) {
        e.stopPropagation()
        const videoWrapper = vid.querySelector('.hpn-video-popup')
        videoWrapper.querySelector('video').pause()
        vid.classList.remove('video-popup-open')
      })
      vid.querySelector('.hpn-video-popup').addEventListener('click', function(e) {
        e.stopPropagation()
        console.log(e.target, this)
        if ( e.target !== this ) return
        this.querySelector('video').pause()
        vid.classList.remove('video-popup-open')
      })
      vid.addEventListener('click', function() {
        vid.classList.add('video-popup-open')
        const videoWrapper = vid.querySelector('.hpn-video-popup')
        videoWrapper.querySelector('video').play()
        
      })
    })
  }

  const nadCtas = document.querySelectorAll('.scroll-top-btn');
  if ( nadCtas ) {
    nadCtas.forEach(cta => {
      cta.addEventListener('click', function(e) {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
        });
        e.preventDefault();
      });
    });
  }

  const freebiePopups = document.querySelectorAll('.pdp-freebie-popup');
  if ( freebiePopups.length ) {
    freebiePopups.forEach(popup => {
      const closeBtn = popup.querySelector('.nad3-close');
      closeBtn.addEventListener('click', function() {
        popup.classList.remove('open');
        document.body.classList.remove('freebie-popup-open');
      });
      popup.addEventListener('click', function(e) {
        if ( e.target.classList.contains('pdp-freebie-popup') ) {
          popup.classList.remove('open');
          document.body.classList.remove('freebie-popup-open');
        }
      });
    });
  }

  gifts.forEach((gift, index) => {
    gift.addEventListener('click', function() {
      if ( index == 5 ) {
        selectOption( purchaseOptions[2] );
      }
      if ( !gift.classList.contains('unlocked') ) return
      const popupLink = gift.dataset.popupLink;
      if ( popupLink ) {
        const popup = document.getElementById(popupLink);
        if ( popup ) {
          document.body.classList.add('freebie-popup-open');
          popup.classList.add('open');
        }
      }
    });
  });

  const popupCtas = document.querySelectorAll('.pdp-freebie-popup .nad3-cta');
  if ( popupCtas.length ) {
    popupCtas.forEach(cta => {
      cta.addEventListener('click', function() {
        document.body.classList.remove('freebie-popup-open');
        cta.closest('.pdp-freebie-popup').classList.remove('open');
        mainForm.querySelector('.mpk-add-to-cart').click();
      });
    });
  }

  const upsellCards = document.querySelectorAll('.nad3-upsell-card');
  if ( upsellCards.length ) {
    upsellCards.forEach(card => {
      card.addEventListener('click', function(e) {
        const popupLink = card.dataset.popupLink;
        if ( popupLink ) {
          selectOption( purchaseOptions[card.dataset.popupOptIndex - 1] );
          freebiePopups.forEach(popup => {
            popup.classList.remove('open');
          });
          const popup = document.getElementById(popupLink);
          if ( popup ) popup.classList.add('open');
        }
      });
    });
  }

})